import type { CaptureStand } from "@/types/types.d";
import { literals } from "@/constants/literals";
import { cn } from "@/lib/styles.utils";
import { useNavigate } from "react-router-dom";
import { Icon } from "@/components/icons/Icon";
import { BASE_URL } from "@/constants/constants";

interface StandSelectorProps {
  stand: CaptureStand;
  isDisabled?: boolean;
}

const StandSelector = ({ stand, isDisabled }: StandSelectorProps) => {
  const navigate = useNavigate();

  const getSelectorIcon = () => {
    if (stand === "reception") return "filingDrawer";
    if (stand === "garage") return "wrench";
    return "senddingBox";
  };

  const startCapturePhotos = () => {
    navigate(`${BASE_URL}/capture/${stand}`);
  };

  return (
    <button
      type="button"
      onClick={startCapturePhotos}
      disabled={isDisabled}
      className={cn(
        "flex-1 basis-0 w-full flex flex-row items-center justify-center rounded-xs",
        isDisabled
          ? "bg-ib-pt-color-gray-300 text-ib-pt-color-gray-1000 border border-ib-pt-color-gray-300"
          : " text-ib-pt-color-blue-800 border",
        !isDisabled && stand === "exits"
          ? "bg-ib-pt-color-blue-500 border-ib-pt-color-blue-500"
          : "",
        !isDisabled && stand === "reception"
          ? "bg-ib-blue border-ib-blue-progress"
          : "",
        !isDisabled && stand === "garage"
          ? "bg-ib-pt-color-blue-300 border-ib-pt-color-blue-500"
          : "",
      )}
    >
      <div className="flex flex-col items-center gap-y-4">
        <div
          className={cn(
            "h-[64px] w-[64px] rounded-full flex justify-center items-center",
            isDisabled ? "bg-ib-pt-color-gray-100" : "bg-ib-pt-color-blue-100",
          )}
        >
          <Icon
            name={getSelectorIcon()}
            className={cn(
              "size-8",
              isDisabled ? "text-ib-pt-color-neutral-500" : "ib-pt-color-black",
            )}
          />
        </div>
        <div
          className={cn(
            "text-[18px] leading-[20px]",
            isDisabled ? "text-ib-pt-color-gray-1000" : "text-ib-pt-color-blue",
          )}
        >
          {literals[stand]}
        </div>
      </div>
    </button>
  );
};

export default StandSelector;
